import { useQuery } from '@tanstack/react-query';
import useGetMarketingData from './useGetMarketingData';
import { getBusinessEmailTemplates } from '../../services/marketing';

interface Options {
  enabled?: boolean;
  onSuccess?: (
    result: Awaited<ReturnType<typeof getBusinessEmailTemplates>>,
  ) => void | Promise<void>;
}

function useGetEmailTemplates({ enabled = true, onSuccess }: Options = {}) {
  const {
    data: marketingData,
    isFetching: isFetchingMarketing,
    isEnabled,
  } = useGetMarketingData();

  const { data, isFetching, isLoading, isError, error, refetch } = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: ['marketing-email-templates', marketingData?.id],
    queryFn: async () => {
      const result = await getBusinessEmailTemplates(marketingData?.id!);

      if (result && onSuccess) {
        await onSuccess(result);
      }

      return result;
    },
    enabled:
      !!marketingData?.id && !isFetchingMarketing && isEnabled && enabled,
  });

  return {
    data,
    isFetching,
    isLoading,
    isError,
    error,
    refetch,
  };
}

export default useGetEmailTemplates;
